import VerificationIndicationIcon from './VerificationIndicationIcon'

export default VerificationIndicationIcon
